import { render, staticRenderFns } from "./UbidotsEndpointView.vue?vue&type=template&id=2363b320&scoped=true&"
import script from "./UbidotsEndpointView.vue?vue&type=script&lang=ts&"
export * from "./UbidotsEndpointView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2363b320",
  null
  
)

export default component.exports